<div nz-row [nzGutter]="16" nzAlign="bottom">
  <p class="px-2 mb-2 info-text-style">
    {{
      'page.training-qualifications.footer.description'
        | translate
          : {
              numberOfTrainings: numberOfTrainings,
              numEmployees: numEmployees,
              numQualifications: numQualifications,
            }
    }}
  </p>
  <div nz-col nzSpan="12">
    <button
      data-test="cancel-button"
      nz-button
      nzType="default"
      [disabled]="loading"
      (click)="cancelDrawerAction()"
    >
      {{ 'general.cancel' | translate }}
    </button>
  </div>
  <div nz-col nzSpan="12">
    <button
      data-test="save-button"
      nz-button
      nzType="primary"
      (click)="saveDrawerAction()"
      [disabled]="loading || saveButtonDisabled"
      [nzLoading]="loading"
    >
      {{ 'general.save' | translate }} ({{ numberOfTrainings }})
    </button>
  </div>
</div>
